'use strict';

const isMargiela = document.body.dataset.sitebrand === "Margiela";
const isMarni = document.body.dataset.sitebrand === "Marni";

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
  $(form).find('.form-control.is-invalid').removeClass('is-invalid');
  $(form).find('.mm-input, .mm-select, .mm6-input').removeClass('-invalid');
  $(form).find('input, select').removeAttr('aria-invalid');
  
  let errorAlert = $(form).find('[data-display-event="login:error"]');
  if (errorAlert.length > 0) {
    errorAlert.empty().hide().attr('aria-hidden', 'true');
  }
}

module.exports = function (formElement, payload) {
  // clear form validation first
  clearFormErrors(formElement);
  $(formElement).find('.alert:not([data-display-event])').remove();

  if (typeof payload === 'object' && payload.fields) {
    Object.keys(payload.fields).forEach(function (key) {
      if (payload.fields[key]) {
        let input = $(formElement).find('[name="' + key + '"]');
        if (input.length > 0) {
          let feedbackElement = input.closest('.mm-input, .mm-select, .mm6-input, .select-container').find('.invalid-feedback');

          if (feedbackElement.length > 0) {
            if (Array.isArray(payload.fields[key])) {
              feedbackElement.html(payload.fields[key].join('<br/>'));
            } else {
              feedbackElement.html(payload.fields[key]);
            }
            
            // Add is-invalid classes
            input.addClass('is-invalid');
            input.attr('aria-invalid', 'true');
            input.closest('.mm-input, .mm-select, .mm6-input').addClass('-invalid');
          }
        }
      }
    });
  }
  if (payload && payload.error) {
    let form = $(formElement).prop('tagName') === 'FORM' ? $(formElement) : $(formElement).parents('form');
    let errorAlert = form.find('[data-display-event="login:error"]');
    if (errorAlert.length > 0) {
      // css('display', 'flex') instead of show(): the alert layout (icon + text) relies on flex,
      // while jQuery show() would set the div's default display: block inline
      errorAlert.html(payload.error.join('<br/>')).css('display', 'flex').attr('aria-hidden', 'false');
    } else {
      const content = '<div class="alert alert-danger invalid-feedback" role="alert">' + payload.error.join('<br/>') + '</div>';
      if (isMargiela && form.attr('name') === 'login-form') {
        form.find('.remember-me-section').before(content);
      } else if(isMarni) {
          if(payload.status.indexOf('CUSTOMER') !== -1) {
              form.find('#account-login-form-email').after($(content).removeClass('alert-danger'));
          } else if (payload.status.indexOf('PASSWORD') !== -1 ) {
              form.find('#login-form-password').after(content);
              form.find('#login-form-password').addClass('error');
          } else {
              form.prepend(content);
          }
      } else {
        form.prepend(content);
      }
    }
  }
};
